import Tag from 'honeydew/Tag';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';

export function MembershipDescriptions() {
    const {
        availableTrialMembership,
        plusMembershipBranding,
        price: { annual: annualPrice } = {},
    } = useAccountPlusMembershipHook();
    const trialDurationDays = availableTrialMembership?.trialDurationDays;

    const plusMembershipPerks = [
        'Your payment method will be charged the full annual fee on signup',
        'Your annual membership will automatically renew (but we’ll email you a reminder beforehand!)',
    ];

    return (
        <>
            <div>
                {trialDurationDays && (
                    <Tag bgColor="plusMembership">
                        <span className="uppercase">{trialDurationDays}-day free trial</span>
                    </Tag>
                )}
                <span className="mt-5 flex pb-5">
                    {trialDurationDays && <p className="mt-[2px]">Then&nbsp;</p>}
                    <p className="font-grotesk-bold">${annualPrice} per year&nbsp;</p>
                    <p className="mt-[2px]">| Billed annually</p>
                </span>
            </div>
            {!availableTrialMembership && (
                <ul className="list-disc pl-20">
                    {plusMembershipPerks.map((perk) => (
                        <li key={perk}>{perk}</li>
                    ))}
                </ul>
            )}
            {availableTrialMembership && (
                <div className="text-body-sm">
                    Enjoy all the {plusMembershipBranding} benefits free for {trialDurationDays} days. We’ll remind you
                    it’s ending before you’re charged!
                </div>
            )}
        </>
    );
}
